import { createContext } from "react";

export const WorkspaceSocketContext = createContext(null);